import { useEffect, useState } from "react";
import { LocationFactorsModal } from "./LocationFactorsModal";
import Modal from "../../modal/Modal";
import { hasRoles } from "../../../utils/roles";
import PropTypes from "prop-types";
import { downloadExcel } from "../currency-exchange/CurrencyExchange.functions";
import { uploadFile } from "./LocationFactors.functions";
import { DisplayError, FileTray } from "./LocationFactors.components";

import DragDropUploadFile from "../../common/generic-upload-button/DragDropUploadFile";

/// props validation | SQ(javascript:S6774)
LocationFactorsUpdate.propTypes = {
  locations: PropTypes.array,
  user: PropTypes.object,
  locationFactors: PropTypes.object,
  region: PropTypes.string,
  country: PropTypes.string,
};
export default function LocationFactorsUpdate(props) {
  const { locations, user } = props;
  const { region, country } = props;
  const { locationFactors } = props;

  const [modal, setModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [error, setError] = useState({});

  useEffect(() => {
    setError({});
  }, [uploadModal]);

  if (!window.location.href.includes("location-factors")) {
    return null;
  }

  if (!hasRoles(user.roles, ["Admin"])) {
    return null;
  }

  async function uploadData(file) {
    await uploadFile(
      region,
      country,
      setError,
      file,
      locationFactors,
      setUploadModal
    );
  }

  return (
    <div>
      <Modal
        title={"Assign Location Factors"}
        Component={LocationFactorsModal}
        modal={modal}
        setModal={setModal}
        locationFactors={locationFactors}
        locations={locations}
        region={region}
        country={country}
      />
      <Modal
        title={"Upload Location Factors"}
        Component={UploadModal}
        modal={uploadModal}
        setModal={setUploadModal}
        error={error}
        setError={setError}
        uploadData={uploadData}
        region={region}
        country={country}
      />
      <div className="tender-price-index-article-control-container">
        <button
          title={"Upload Location Factors"}
          id={"button-location-factor-upload"}
          className="benchmark-control-export-button"
          onClick={() => {
            setUploadModal(true);
          }}
        >
          <i className="fa fa-upload" aria-hidden="true"></i>
        </button>

        <button
          className="benchmark-control-export-button"
          title={"Download Location Factors"}
          id={"location-factors-download-button"}
          onClick={() => {
            downloadExcel(
              "LocatonFactors",
              prepareLocationsFactorsForDownload({
                locations: locations.map((d) => {
                  return {
                    region: d.region,
                    country: d.country,
                    city: d.city,
                    factor: d.factor,
                    globalfactor: d.globalfactor,
                  };
                }),
              }),
              "location-factors"
            );
          }}
        >
          <i className="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>

      <div className="tender-price-index-article-control-container">
        <button
          id={"button-location-factor"}
          className={"location-factor-set-button"}
          onClick={() => {
            setModal(true);
          }}
        >
          Update Location Factors
        </button>
      </div>
    </div>
  );
}

// Add PropTypes validation
LocationFactorsUpdate.propTypes = {
  locations: PropTypes.array.isRequired,
  user: PropTypes.shape({
    roles: PropTypes.array.isRequired,
  }).isRequired,
  region: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  locationFactors: PropTypes.array.isRequired,
};

UploadModal.propTypes = {
  uploadData: PropTypes.func,
  error: PropTypes.object,
};

export function UploadModal(props) {
  const { uploadData, error, setError } = props;

  const [file, setFile] = useState([]); // file to upload
  const [highlight, setHighlight] = useState(false);

  // To reset File Input
  const [inputKey, setInputKey] = useState(0);

  const handleUploadClick = async () => {
    await uploadData(file[0]);
  };

  return (
    <div className="location-factors-upload-modal">
      <div className="general-row-container-double">
        <FileTray file={file} />
      </div>
      <div className="general-row-container">
        <DragDropUploadFile
          setFile={setFile}
          allowMultiple={false}
          highlight={highlight}
          setHighlight={setHighlight}
          error={error}
          setError={setError}
          inputKey={inputKey}
          setInputKey={setInputKey}
        />
      </div>
      <div className="general-row-container">
        <DisplayError error={error} />
      </div>
      <div className="general-row-container-double">
        <button
          id={"button-location-factor-upload-dialog"}
          className="general-upload-button"
          onClick={handleUploadClick}
        >
          Upload
        </button>
      </div>
    </div>
  );
}

function prepareLocationsFactorsForDownload(data) {
  let locationTable = [];
  let dataRow = [
    "Region",
    "Country",
    "City",
    "Location Factor",
    "Global Factor",
  ];
  locationTable.push(dataRow);
  data.locations.forEach((element) => {
    dataRow = [
      element.region,
      element.country,
      element.city,
      element.factor,
      element.globalfactor,
    ];
    locationTable.push(dataRow);
  });
  return locationTable;
}
